import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b83e8f72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "backdrop" }
const _hoisted_2 = { class: "modal-screen" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "float-start" }, "Добавить категорию", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clear mt-5" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Название", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("button", {
        type: "button",
        class: "btn-close float-end",
        "aria-label": "Close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeWindow()))
      }),
      _hoisted_4,
      _hoisted_5,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newTitle) = $event))
      }, null, 512), [
        [_vModelText, _ctx.newTitle]
      ]),
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addCategory()))
      }, " Добавить ")
    ])
  ]))
}